import { useGameSocket } from './hooks/useGameSocket';
import { usePhase } from './store/gameStore';
import Lobby from './Lobby';
import GameShell from './GameShell';
import SeoFooter from './components/SeoFooter';
import { EtooLogo } from './components/EtooLogo';

export default function App() {
  const socket = useGameSocket();
  const phase = usePhase();

  return (
    <>
      {phase === 'lobby' ? <Lobby socket={socket} /> : <GameShell socket={socket} />}
      <EtooLogo />
      <SeoFooter />
    </>
  );
}